import React, {useMemo} from 'react';
import {useShallow} from 'zustand/react/shallow';
import FeatureFlag from 'client/components/FeatureFlag/FeatureFlag.react';

import {useQuestionTranslationStore} from '../../shared/TranslationSection';
import PassageCorrectionExplanation from '../legacy/PassageCorrectionExplanation.react';

const PassageCorrectionExplanationWrapper = (props: any) => {
  const {showAnswerTranslation, translationInfo} = useQuestionTranslationStore(
    useShallow((state) => ({
      showAnswerTranslation: state.toggleStatus.answer,
      translationInfo: state.translatedQuestionInfo
    }))
  );

  const questionText = useMemo(() => {
    return translationInfo?.uncorrected_text;
  }, [translationInfo]);

  const solutionText = useMemo(() => {
    return translationInfo?.solution_text;
  }, [translationInfo]);

  return (
    <FeatureFlag name='assignment_question_translations'>
      <PassageCorrectionExplanation
        {...props}
        showTranslation={showAnswerTranslation}
        translatedUncorrectedText={questionText}
        translatedSolutionText={solutionText}
      />
      <FeatureFlag.Fallback>
        <PassageCorrectionExplanation {...props} />
      </FeatureFlag.Fallback>
    </FeatureFlag>
  );
};

export default PassageCorrectionExplanationWrapper;
